const v = {
  name: "Munich",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4,3.1C1.7,3.6,0,5.6,0,8v3h1v13h2v-9h4v9h2v-4h15v-2h-3v-7h1V8c0-2.4-1.7-4.4-4-4.9V0h-2v3.1
			c-2.3,0.5-4,2.5-4,4.9v3h1v7H9v-7h1V8c0-2.4-1.7-4.4-4-4.9V0H4V3.1z M15,18v-3h4v3H15z M7,13H3v-2h4V13z M8,9H2V8c0-1.7,1.3-3,3-3
			s3,1.3,3,3V9z M17,5c1.7,0,3,1.3,3,3v1h-6V8C14,6.3,15.3,5,17,5z M19,11v2h-4v-2H19z"/>
	</g>
</g>
</svg>
  `
};
export {
  v as Munich
};
